import { defineStore } from 'pinia'

export type GameSlotJackpotResponseData = Record<string, number>

export interface JackpotXocdia {
  gameId: string
  gameName: string
  value: number
}

interface Jackpot {
  data: GameSlotJackpotResponseData,
  xocdia: JackpotXocdia
}
const STORE_NAME = 'jackpot'

export const useJackpotStore = defineStore(STORE_NAME, {
  state: (): Jackpot => ({
    data: {},
    xocdia: {
      gameId: '',
      gameName: '',
      value: 0
    }
  }),
  persist: false,
  actions: {
    setJackpot(data: GameSlotJackpotResponseData): void {
      this.data = data
    },
    getJackpot(): GameSlotJackpotResponseData {
      return this.data
    },
    setXocDiaJackpot(jackpot: JackpotXocdia): void {
      this.xocdia = jackpot
    },
    getXocDiaJackpot(): JackpotXocdia {
      return this.xocdia
    }
  }
})
